// @flow
import { debounceTime, catchError, map, mergeMap } from 'rxjs/operators/index';
import { of, throwError } from 'rxjs';
import { httpErrorsCodeMap } from '../../http';
import update from 'immutability-helper';
import {
  getListUserWishListsApi,
  getUserWishListApi,
  postCreateUserWishListApi,
  putUserWishListApi,
  deleteUserWishListApi,
  postProductApi,
  editProductApi,
  deleteProductApi,
  uploadImageApi,
  uploadImageURLApi,
  postLikeApi,
  postUnlikeApi,
  endpoints
} from './api';
import { setNewAlert } from '../alert/duck';
import { ofType } from 'redux-observable';
import { push } from 'react-router-redux';
import { encodeProduct } from './utils/encode';
import { dataURItoBlob } from '../../utils/file';

import deportes from '../../assets/img/wish-list/deportes.jpg';
import foto_video from '../../assets/img/wish-list/foto_video.jpg';
import gamers from '../../assets/img/wish-list/gamers.jpg';

import type { HTTPError } from '../../error';
import type { WishList, WishListItem, WishListProduct } from '../../entities';
import type { Observable } from 'rxjs/index';
import type { WishListRequest, UploadImageResponse } from './api';

export type WishListAction = {
  +type: string;
  +error?: HTTPError;
  +imageId?: string;
  +nameSlug?: string;
  +userId?: string;
  +productId?: string;
  +wishList?: WishList;
  +wishListRequest?: WishListRequest;
  +wishLists?: WishList[];
  +product?: WishListProduct;
  +liked?: boolean;
};

export type WishListState = {
  +error?: HTTPError;
  +wishLists?: WishList[];
  +currentWishList?: WishList;
  +isFetchingWishLists?: boolean;
  +isFetchingWishList?: boolean;
  +isPostingWishList?: boolean;
  +isPuttingWishList?: boolean;
  +isDeletingWishList?: boolean;
  +isPostingProduct?: boolean;
  +isEditingProduct?: boolean;
  +isDeletingProduct?: boolean;
  +isEditingLike?: boolean;
};

// Action
const WISH_LIST_FETCH_LIST_USER_WISH_LISTS_REQUEST = 'WISH_LIST_FETCH_LIST_USER_WISH_LISTS_REQUEST';
const WISH_LIST_FETCH_LIST_USER_WISH_LISTS_SUCCESS = 'WISH_LIST_FETCH_LIST_USER_WISH_LISTS_SUCCESS';
const WISH_LIST_FETCH_LIST_USER_WISH_LISTS_ERROR = 'WISH_LIST_FETCH_LIST_USER_WISH_LISTS_ERROR';

const WISH_LIST_FETCH_USER_WISH_LIST_REQUEST = 'WISH_LIST_FETCH_USER_WISH_LIST_REQUEST';
const WISH_LIST_FETCH_USER_WISH_LIST_SUCCESS = 'WISH_LIST_FETCH_USER_WISH_LIST_SUCCESS';
const WISH_LIST_FETCH_USER_WISH_LIST_ERROR = 'WISH_LIST_FETCH_USER_WISH_LIST_ERROR';

const WISH_LIST_POST_CREATE_USER_WISH_LIST_REQUEST = 'WISH_LIST_POST_CREATE_USER_WISH_LIST_REQUEST';
const WISH_LIST_POST_IMAGE_SUCCESS = 'WISH_LIST_POST_IMAGE_SUCCESS';
const WISH_LIST_POST_CREATE_USER_WISH_LIST_SUCCESS = 'WISH_LIST_POST_CREATE_USER_WISH_LIST_SUCCESS';
const WISH_LIST_POST_CREATE_USER_WISH_LIST_ERROR = 'WISH_LIST_POST_CREATE_USER_WISH_LIST_ERROR';

const WISH_LIST_EDIT_USER_WISH_LIST_REQUEST = 'WISH_LIST_EDIT_USER_WISH_LIST_REQUEST';
const WISH_LIST_EDIT_USER_WISH_LIST_SUCCESS = 'WISH_LIST_EDIT_USER_WISH_LIST_SUCCESS';
const WISH_LIST_EDIT_USER_WISH_LIST_ERROR = 'WISH_LIST_EDIT_USER_WISH_LIST_ERROR';

const WISH_LIST_DELETE_USER_WISH_LIST_REQUEST = 'WISH_LIST_DELETE_USER_WISH_LIST_REQUEST';
const WISH_LIST_DELETE_USER_WISH_LIST_SUCCESS = 'WISH_LIST_DELETE_USER_WISH_LIST_SUCCESS';
const WISH_LIST_DELETE_USER_WISH_LIST_ERROR = 'WISH_LIST_DELETE_USER_WISH_LIST_ERROR';

const WISH_LIST_POST_PRODUCT_REQUEST = 'WISH_LIST_POST_PRODUCT_REQUEST';
const WISH_LIST_POST_PRODUCT_IMAGE_SUCCESS = 'WISH_LIST_POST_PRODUCT_IMAGE_SUCCESS';
const WISH_LIST_POST_PRODUCT_SUCCESS = 'WISH_LIST_POST_PRODUCT_SUCCESS';
const WISH_LIST_POST_PRODUCT_ERROR = 'WISH_LIST_POST_PRODUCT_ERROR';

const WISH_LIST_EDIT_PRODUCT_REQUEST = 'WISH_LIST_EDIT_PRODUCT_REQUEST';
const WISH_LIST_EDIT_PRODUCT_IMAGE_SUCCESS = 'WISH_LIST_EDIT_PRODUCT_IMAGE_SUCCESS';
const WISH_LIST_EDIT_PRODUCT_SUCCESS = 'WISH_LIST_EDIT_PRODUCT_SUCCESS';
const WISH_LIST_EDIT_PRODUCT_ERROR = 'WISH_LIST_EDIT_PRODUCT_ERROR';

const WISH_LIST_DELETE_PRODUCT_REQUEST = 'WISH_LIST_DELETE_PRODUCT_REQUEST';
const WISH_LIST_DELETE_PRODUCT_SUCCESS = 'WISH_LIST_DELETE_PRODUCT_SUCCESS';
const WISH_LIST_DELETE_PRODUCT_ERROR = 'WISH_LIST_DELETE_PRODUCT_ERROR';

const WISH_LIST_EDIT_LIKE_REQUEST = 'WISH_LIST_EDIT_LIKE_REQUEST';
const WISH_LIST_EDIT_LIKE_SUCCESS = 'WISH_LIST_EDIT_LIKE_SUCCESS';
const WISH_LIST_EDIT_LIKE_ERROR = 'WISH_LIST_EDIT_LIKE_ERROR';

const WISH_LIST_RESET_STATE = 'WISH_LIST_RESET_STATE';

// Actions creators
export function getListUserWishLists(): WishListAction {
  return {
    type: WISH_LIST_FETCH_LIST_USER_WISH_LISTS_REQUEST,
  };
}

export function getListUserWishListsSuccess(wishLists: WishList[]): WishListAction {
  return {
    type: WISH_LIST_FETCH_LIST_USER_WISH_LISTS_SUCCESS,
    wishLists,
  };
}

export function getListUserWishListsError(error: HTTPError): WishListAction {
  return {
    type: WISH_LIST_FETCH_LIST_USER_WISH_LISTS_SUCCESS,
    error,
  };
}

export function getUserWishList(userId: string, nameSlug: string): WishListAction {
  return {
    type: WISH_LIST_FETCH_USER_WISH_LIST_REQUEST,
    userId,
    nameSlug,
  };
}

export function getUserWishListSuccess(wishList: any): WishListAction {
  return {
    type: WISH_LIST_FETCH_USER_WISH_LIST_SUCCESS,
    wishList,
  };
}

export function getUserWishListError(error: HTTPError): WishListAction {
  return {
    type: WISH_LIST_FETCH_USER_WISH_LIST_ERROR,
    error,
  };
}

export function postCreateUserWishList(wishListRequest: WishListRequest): WishListAction {
  return {
    type: WISH_LIST_POST_CREATE_USER_WISH_LIST_REQUEST,
    wishListRequest,
  };
}

export function postImageSuccess(wishListRequest: WishListRequest): WishListAction {
  return {
    type: WISH_LIST_POST_IMAGE_SUCCESS,
    wishListRequest,
  }
}

export function postCreateUserWishListSuccess(wishList: WishList): WishListAction {
  return {
    type: WISH_LIST_POST_CREATE_USER_WISH_LIST_SUCCESS,
    wishList,
  };
}

export function postCreateUserWishListError(error: HTTPError): WishListAction {
  return {
    type: WISH_LIST_POST_CREATE_USER_WISH_LIST_ERROR,
    error,
  };
}

export function putEditUserWishList(wishListRequest: WishListRequest, nameSlug: string): WishListAction {
  return {
    type: WISH_LIST_EDIT_USER_WISH_LIST_REQUEST,
    wishListRequest,
    nameSlug,
  };
}

export function putEditUserWishListSuccess(wishList: WishList): WishListAction {
  return {
    type: WISH_LIST_EDIT_USER_WISH_LIST_SUCCESS,
    wishList,
  };
}

export function putEditUserWishListError(error: HTTPError): WishListAction {
  return {
    type: WISH_LIST_EDIT_USER_WISH_LIST_ERROR,
    error,
  };
}

export function deleteUserWishList(nameSlug: string): WishListAction {
  return {
    type: WISH_LIST_DELETE_USER_WISH_LIST_REQUEST,
    nameSlug,
  };
}

export function deleteUserWishListSuccess(wishLists: WishList[]): WishListAction {
  return {
    type: WISH_LIST_DELETE_USER_WISH_LIST_SUCCESS,
    wishLists,
  };
}

export function deleteUserWishListError(error: HTTPError): WishListAction {
  return {
    type: WISH_LIST_DELETE_USER_WISH_LIST_ERROR,
    error,
  };
}

export function postProduct(product: WishListProduct, userId: string, nameSlug: string): WishListAction {
  return {
    type: WISH_LIST_POST_PRODUCT_REQUEST,
    product,
    userId,
    nameSlug,
  };
}

export function postProductImageSuccess(imageId: string, product: WishListProduct, userId: string, nameSlug: string): WishListAction {
  return {
    type: WISH_LIST_POST_PRODUCT_IMAGE_SUCCESS,
    imageId,
    product,
    userId,
    nameSlug,
  };
}

export function postProductSuccess(wishList: WishList): WishListAction {
  return {
    type: WISH_LIST_POST_PRODUCT_SUCCESS,
    wishList,
  };
}

export function postProductError(error: HTTPError): WishListAction {
  return {
    type: WISH_LIST_POST_PRODUCT_ERROR,
    error,
  };
}

export function editProduct(product: WishListProduct, productId: string,
                            userId: string, nameSlug: string): WishListAction {
  return {
    type: WISH_LIST_EDIT_PRODUCT_REQUEST,
    product,
    productId,
    userId,
    nameSlug,
  };
}

export function editProductImageSuccess(product: WishListProduct, productId: string, userId: string,
                                        nameSlug: string, imageId?: string): WishListAction {
  return {
    type: WISH_LIST_EDIT_PRODUCT_IMAGE_SUCCESS,
    product,
    productId,
    userId,
    nameSlug,
    imageId,
  };
}

export function editProductSuccess(wishList: WishList): WishListAction {
  return {
    type: WISH_LIST_EDIT_PRODUCT_SUCCESS,
    wishList,
  };
}

export function editProductError(error: HTTPError): WishListAction {
  return {
    type: WISH_LIST_EDIT_PRODUCT_ERROR,
    error,
  };
}

export function deleteProduct(productId: string, userId: string, nameSlug: string): WishListAction {
  return {
    type: WISH_LIST_DELETE_PRODUCT_REQUEST,
    productId,
    userId,
    nameSlug,
  };
}

export function deleteProductSuccess(wishList: WishList): WishListAction {
  return {
    type: WISH_LIST_DELETE_PRODUCT_SUCCESS,
    wishList,
  };
}

export function deleteProductError(error: HTTPError): WishListAction {
  return {
    type: WISH_LIST_DELETE_PRODUCT_ERROR,
    error,
  };
}

export function editLike(liked: boolean, userId: string, nameSlug: string): WishListAction {
  return {
    type: WISH_LIST_EDIT_LIKE_REQUEST,
    liked,
    userId,
    nameSlug,
  };
}

export function editLikeSuccess(wishList: WishList): WishListAction {
  return {
    type: WISH_LIST_EDIT_LIKE_SUCCESS,
    wishList,
  };
}

export function editLikeErrorFn(error: HTTPError): WishListAction {
  return {
    type: WISH_LIST_EDIT_LIKE_ERROR,
    error,
  };
}

export function resetWishListState(): WishListAction {
  return {
    type: WISH_LIST_RESET_STATE,
  };
}

export const actions = {
  WISH_LIST_FETCH_LIST_USER_WISH_LISTS_REQUEST,
  WISH_LIST_FETCH_LIST_USER_WISH_LISTS_SUCCESS,
  WISH_LIST_FETCH_LIST_USER_WISH_LISTS_ERROR,
  WISH_LIST_FETCH_USER_WISH_LIST_REQUEST,
  WISH_LIST_FETCH_USER_WISH_LIST_SUCCESS,
  WISH_LIST_FETCH_USER_WISH_LIST_ERROR,
  WISH_LIST_POST_CREATE_USER_WISH_LIST_REQUEST,
  WISH_LIST_POST_IMAGE_SUCCESS,
  WISH_LIST_POST_CREATE_USER_WISH_LIST_SUCCESS,
  WISH_LIST_POST_CREATE_USER_WISH_LIST_ERROR,
  WISH_LIST_EDIT_USER_WISH_LIST_REQUEST,
  WISH_LIST_EDIT_USER_WISH_LIST_SUCCESS,
  WISH_LIST_EDIT_USER_WISH_LIST_ERROR,
  WISH_LIST_DELETE_USER_WISH_LIST_REQUEST,
  WISH_LIST_DELETE_USER_WISH_LIST_SUCCESS,
  WISH_LIST_DELETE_USER_WISH_LIST_ERROR,
  WISH_LIST_POST_PRODUCT_REQUEST,
  WISH_LIST_POST_PRODUCT_IMAGE_SUCCESS,
  WISH_LIST_POST_PRODUCT_SUCCESS,
  WISH_LIST_POST_PRODUCT_ERROR,
  WISH_LIST_EDIT_PRODUCT_REQUEST,
  WISH_LIST_EDIT_PRODUCT_SUCCESS,
  WISH_LIST_EDIT_PRODUCT_ERROR,
  WISH_LIST_DELETE_PRODUCT_REQUEST,
  WISH_LIST_DELETE_PRODUCT_SUCCESS,
  WISH_LIST_DELETE_PRODUCT_ERROR,
  WISH_LIST_EDIT_LIKE_REQUEST,
  WISH_LIST_EDIT_LIKE_SUCCESS,
  WISH_LIST_EDIT_LIKE_ERROR,
  WISH_LIST_RESET_STATE,
  getListUserWishLists,
  getListUserWishListsSuccess,
  getListUserWishListsError,
  getUserWishList,
  getUserWishListSuccess,
  getUserWishListError,
  postCreateUserWishList,
  postCreateUserWishListSuccess,
  postImageSuccess,
  postCreateUserWishListError,
  putEditUserWishList,
  putEditUserWishListSuccess,
  putEditUserWishListError,
  deleteUserWishList,
  deleteUserWishListSuccess,
  deleteUserWishListError,
  postProduct,
  postProductImageSuccess,
  postProductSuccess,
  postProductError,
  editProduct,
  editProductImageSuccess,
  editProductSuccess,
  editProductError,
  deleteProduct,
  deleteProductSuccess,
  deleteProductError,
  editLike,
  editLikeSuccess,
  editLikeErrorFn,
  resetWishListState,
};

const initialState: WishListState = {};

// Reducer

export default function reducer(state: WishListState = initialState,
                                action: WishListAction): WishListState {
  switch (action.type) {
    case WISH_LIST_FETCH_LIST_USER_WISH_LISTS_REQUEST:
      return {
        isFetchingWishLists: true,
      };
    case WISH_LIST_FETCH_LIST_USER_WISH_LISTS_SUCCESS:
      if (action.wishLists && action.wishLists[0]) {
        const wl = action.wishLists[0];
        return {
          wishLists: action.wishLists,
          currentWishList: wl,
        }
      }
      return {
        wishLists: action.wishLists,
      };
    case WISH_LIST_FETCH_LIST_USER_WISH_LISTS_ERROR:
      return {
        error: action.error,
      };
    case WISH_LIST_FETCH_USER_WISH_LIST_REQUEST:
      return {
        isFetchingWishList: true,
      };
    case WISH_LIST_FETCH_USER_WISH_LIST_SUCCESS:
      return {
        currentWishList: action.wishList,
      };
    case WISH_LIST_FETCH_USER_WISH_LIST_ERROR:
      return {
        error: action.error,
      };
    case WISH_LIST_POST_CREATE_USER_WISH_LIST_REQUEST:
      return {
        isPostingWishList: true,
      };
    case WISH_LIST_POST_CREATE_USER_WISH_LIST_SUCCESS:
      return {
        currentWishList: action.wishList,
      };
    case WISH_LIST_POST_CREATE_USER_WISH_LIST_ERROR:
      return {
        error: action.error,
      };
    case WISH_LIST_EDIT_USER_WISH_LIST_REQUEST:
      return {
        isPuttingWishList: true,
      };
    case WISH_LIST_EDIT_USER_WISH_LIST_SUCCESS:
      if (action.wishList) {
        return update(state, {
          $unset: ['isPuttingWishList'],
          currentWishList: {
            name: { $set: action.wishList.name },
            image: { $set: action.wishList.image },
            public: { $set: action.wishList.public },
          }
        });
      }
      return state;
    case WISH_LIST_EDIT_USER_WISH_LIST_ERROR:
      return {
        error: action.error,
      };
    case WISH_LIST_DELETE_USER_WISH_LIST_REQUEST:
      return {
        isDeletingWishList: true,
      };
    case WISH_LIST_DELETE_USER_WISH_LIST_SUCCESS:
      return {
        wishLists: action.wishLists,
      };
    case WISH_LIST_DELETE_USER_WISH_LIST_ERROR:
      return {
        error: action.error,
      };

    case WISH_LIST_POST_PRODUCT_REQUEST:
      return update(state, {
        isPostingProduct: { $set: true },
        $unset: ['error'],
      });
    case WISH_LIST_POST_PRODUCT_SUCCESS:
      return update(state, {
        currentWishList: { $set: action.wishList },
        $unset: ['isPostingProduct'],
      });
    case WISH_LIST_POST_PRODUCT_ERROR:
      return update(state, {
        $unset: ['isPostingProduct'],
        error: { $set: action.error },
      });
    case WISH_LIST_EDIT_PRODUCT_REQUEST:
      return update(state, {
        isEditingProduct: { $set: true },
        $unset: ['error'],
      });
    case WISH_LIST_EDIT_PRODUCT_SUCCESS:
      return update(state, {
        currentWishList: { $set: action.wishList },
        $unset: ['isEditingProduct'],
      });
    case WISH_LIST_EDIT_PRODUCT_ERROR:
      return update(state, {
        $unset: ['isEditingProduct'],
        error: { $set: action.error },
      });
    case WISH_LIST_DELETE_PRODUCT_REQUEST:
      return update(state, {
        isDeletingProduct: { $set: true },
        $unset: ['error'],
      });
    case WISH_LIST_DELETE_PRODUCT_SUCCESS:
      return update(state, {
        currentWishList: { $set: action.wishList },
        $unset: ['isDeletingProduct'],
      });
    case WISH_LIST_DELETE_PRODUCT_ERROR:
      return update(state, {
        $unset: ['isDeletingProduct'],
        error: { $set: action.error },
      });
    case WISH_LIST_EDIT_LIKE_REQUEST:
      if (!state.currentWishList) return state;
      return update(state, {
        isEditingLike: { $set: true },
        currentWishList: {
          $set: update(state.currentWishList, {
            liked: { $set: action.liked },
            likes: {
              $set: action.liked ?
                state.currentWishList.likes + 1 : state.currentWishList.likes - 1
            },
          }),
        },
        $unset: ['error'],
      });
    case WISH_LIST_EDIT_LIKE_SUCCESS:
      return update(state, {
        $unset: ['isEditingLike'],
      });
    case WISH_LIST_EDIT_LIKE_ERROR:
      return update(state, {
        $unset: ['isEditingLike'],
        error: { $set: action.error },
      });
    case WISH_LIST_RESET_STATE:
      return initialState;
    default:
      return state;
  }
}

// Epics

export const customWishLists: { [key: string]: WishList } = {
  'esenciales-para-foto-y-video': {
    'image': foto_video,
    'items': [
      {
        'id': 1,
        'amount': 1,
        'category': {
          'id': 10,
        },
        'detail': 'Size: Wireless Go\n',
        'freeShipping': true,
        'image': 'https://images-na.ssl-images-amazon.com/images/I/41CbKwVmXJL._SL1000_.jpg',
        'name': 'Rode Wireless Go - Compact Wireless Microphone System',
        'onlineStore': {
          'id': 'ST04287850',
          'logo': 'https://res.cloudinary.com/qempo/image/upload/v1551903426/static/stores/Amazon.png',
          'name': 'Amazon',
          'type': 'online-store'
        },
        'price': '199.00',
        'taxFree': false,
        'url': 'https://www.amazon.com/Rode-Wireless-Go-Microphone-Transmitter/dp/B07QGGBNMN/ref=sr_1_4?keywords=wireless+microphone+for+camera&qid=1571613679&sr=8-4',
        'volumeTier': 'S'
      },
      {
        'id': 2,
        'amount': 1,
        'category': {
          'id': 10,
        },
        'detail': '',
        'freeShipping': true,
        'image': 'https://images-na.ssl-images-amazon.com/images/I/71Nnvqi6PLL._SL1500_.jpg',
        'name': 'DJI osmo Mobile 2 Handheld Smartphone Gimbal ',
        'onlineStore': {
          'id': 'ST04287851',
          'logo': 'https://res.cloudinary.com/qempo/image/upload/v1551903426/static/stores/Amazon.png',
          'name': 'Amazon',
          'type': 'online-store'
        },
        'price': '119.00',
        'taxFree': false,
        'url': 'https://www.amazon.com/DJI-Mobile-Handheld-Smartphone-Gimbal/dp/B078XJSCYG/ref=sr_1_5?keywords=camera+stabilizer+dji&qid=1571613731&sr=8-5',
        'volumeTier': 'M'
      },
      {
        'id': 3,
        'amount': 1,
        'category': {
          'id': 5,
        },
        'detail': 'Configuration: Recorder',
        'freeShipping': true,
        'image': 'https://images-na.ssl-images-amazon.com/images/I/41SIMdKPrHL.jpg',
        'name': 'Zoom H2n Handy Recorder',
        'onlineStore': {
          'id': 'ST04287852',
          'logo': 'https://res.cloudinary.com/qempo/image/upload/v1551903426/static/stores/Amazon.png',
          'name': 'Amazon',
          'type': 'online-store'
        },
        'price': '159.99',
        'taxFree': false,
        'url': 'https://www.amazon.com/Zoom-H2N-H2n-Handy-Recorder/dp/B005CQ2ZY6/ref=sr_1_3?keywords=voice+recorder+zoom&qid=1571614190&sr=8-3',
        'volumeTier': 'S'
      },
      {
        'id': 4,
        'amount': 1,
        'category': {
          'id': 5,
        },
        'detail': 'Color: Black',
        'freeShipping': true,
        'image': 'https://images-na.ssl-images-amazon.com/images/I/61vj2BPDpuL._SL1500_.jpg',
        'name': 'Anker PowerCore 26800 Portable Charger',
        'onlineStore': {
          'id': 'ST04287853',
          'logo': 'https://res.cloudinary.com/qempo/image/upload/v1551903426/static/stores/Amazon.png',
          'name': 'Amazon',
          'type': 'online-store'
        },
        'price': '65.99',
        'taxFree': false,
        'url': 'https://www.amazon.com/Anker-PowerCore-Portable-Double-Speed-Recharging/dp/B01JIWQPMW/ref=sxts_b2b_sx_reorder?keywords=external+battery&pd_rd_i=B01JIWQPMW&pd_rd_r=cdbb078f-314f-4b3c-8bbf-1b758a86c1d4&pd_rd_w=dJdao&pd_rd_wg=Zo20w&pf_rd_p=a7bfb983-e674-4caa-917b-596cc469ad1f&pf_rd_r=F9Y5Q51ASVC2R5GJG6MW&qid=1571613806',
        'volumeTier': 'S'
      },
      {
        'id': 5,
        'amount': 1,
        'category': {
          'id': 5,
        },
        'detail': '',
        'freeShipping': true,
        'image': 'https://images-na.ssl-images-amazon.com/images/I/51K52ZFwH%2BL._SL1031_.jpg',
        'name': 'Skylight Frame: 10 inch WiFi Digital Picture Frame',
        'onlineStore': {
          'id': 'ST04287854',
          'logo': 'https://res.cloudinary.com/qempo/image/upload/v1551903426/static/stores/Amazon.png',
          'name': 'Amazon',
          'type': 'online-store'
        },
        'price': '159.00',
        'taxFree': false,
        'url': 'https://www.amazon.com/Skylight-Frame-Digital-Picture-Anywhere/dp/B01N7ENHO6/ref=sxin_2_ac_d_pm?ac_md=4-2-QmV0d2VlbiAkMTAwIGFuZCAkMjAw-ac_d_pm&keywords=digital+frame&pd_rd_i=B01N7ENHO6&pd_rd_r=e21165a3-220b-47e1-8aaf-42d98d186620&pd_rd_w=IFIpo&pd_rd_wg=lJ4JY&pf_rd_p=02e79b16-eab7-4369-852f-d04a58a4d9b5&pf_rd_r=ZQNDB7TXJ3804CRZA3GP&psc=1&qid=1571614451',
        'volumeTier': 'M'
      },
      {
        'id': 6,
        'amount': 1,
        'category': {
          'id': 10,
        },
        'detail': 'Size: 256GB',
        'freeShipping': true,
        'image': 'https://images-na.ssl-images-amazon.com/images/I/81pKCpErV9L._SL1500_.jpg',
        'name': 'SanDisk 256GB Extreme PRO SDXC UHS-I Card',
        'onlineStore': {
          'id': 'ST04287855',
          'logo': 'https://res.cloudinary.com/qempo/image/upload/v1551903426/static/stores/Amazon.png',
          'name': 'Amazon',
          'type': 'online-store'
        },
        'price': '72.38',
        'taxFree': false,
        'url': 'https://www.amazon.com/SanDisk-256GB-Extreme-UHS-I-SDSDXXY-256G-GN4IN/dp/B07H9VX76D/ref=sr_1_4?keywords=sd+memory&qid=1571613869&sr=8-4',
        'volumeTier': 'XS'
      },
      {
        'id': 7,
        'amount': 1,
        'category': {
          'id': 2,
        },
        'detail': 'Capacity: 4TB',
        'freeShipping': true,
        'image': 'https://images-na.ssl-images-amazon.com/images/I/81WFWi9sKlL._SL1500_.jpg',
        'name': 'WD 4TB Elements Portable External Hard Drive',
        'onlineStore': {
          'id': 'ST04287856',
          'logo': 'https://res.cloudinary.com/qempo/image/upload/v1551903426/static/stores/Amazon.png',
          'name': 'Amazon',
          'type': 'online-store'
        },
        'price': '99.99',
        'taxFree': false,
        'url': 'https://www.amazon.com/Western-Digital-Elements-Portable-External/dp/B0713WPGLL/ref=sxin_2_ac_d_pm?ac_md=5-1-QmV0d2VlbiAkNzUgYW5kICQxMDA%3D-ac_d_pm&keywords=external+hard+drive&pd_rd_i=B0713WPGLL&pd_rd_r=3d06f55a-4c22-49ea-b24d-783332193c29&pd_rd_w=jUCkX&pd_rd_wg=qIAi5&pf_rd_p=02e79b16-eab7-4369-852f-d04a58a4d9b5&pf_rd_r=JNGKF98YS00E53EKZVFV&psc=1&qid=1571613920',
        'volumeTier': 'S'
      },
      {
        'id': 8,
        'amount': 1,
        'category': {
          'id': 10,
        },
        'detail': 'Size: NEW 2.0 SINGLE PACK (Accessories Incl)',
        'freeShipping': true,
        'image': 'https://images-na.ssl-images-amazon.com/images/I/51VUHcyxDCL._SL1040_.jpg',
        'name': 'Lume Cube 2.0 - Daylight Balanced LED Light',
        'onlineStore': {
          'id': 'ST04287857',
          'logo': 'https://res.cloudinary.com/qempo/image/upload/v1551903426/static/stores/Amazon.png',
          'name': 'Amazon',
          'type': 'online-store'
        },
        'price': '89.95',
        'taxFree': false,
        'url': 'https://www.amazon.com/Lume-Cube-2-0-Daylight-Panasonic/dp/B07XF786FR/ref=sr_1_2_sspa?keywords=lume+cube&qid=1571614011&sr=8-2-spons&psc=1&spLa=ZW5jcnlwdGVkUXVhbGlmaWVyPUEySE1IQ0IzQjRLSjU5JmVuY3J5cHRlZElkPUEwOTMwODg4M1Q2OThYUjVHMlg0RyZlbmNyeXB0ZWRBZElkPUEwNDAxMjA4M1M2OVlaVEhKMTJGQyZ3aWRnZXROYW1lPXNwX2F0ZiZhY3Rpb249Y2xpY2tSZWRpcmVjdCZkb05vdExvZ0NsaWNrPXRydWU=',
        'volumeTier': 'S'
      },
      {
        'id': 9,
        'amount': 1,
        'category': {
          'id': 9,
        },
        'detail': 'Color: Black',
        'freeShipping': true,
        'image': 'https://images-na.ssl-images-amazon.com/images/I/91B90xeYGQL._SL1500_.jpg',
        'name': 'Peak Design Everyday Backpack Black Camera Bag\n',
        'onlineStore': {
          'id': 'ST04287858',
          'logo': 'https://res.cloudinary.com/qempo/image/upload/v1551903426/static/stores/Amazon.png',
          'name': 'Amazon',
          'type': 'online-store'
        },
        'price': '259.95',
        'taxFree': false,
        'url': 'https://www.amazon.com/Peak-Design-Everyday-Backpack-Camera/dp/B075GP6M9N/ref=sr_1_11_sspa?keywords=manfrotto&qid=1571614249&sr=8-11-spons&psc=1&spLa=ZW5jcnlwdGVkUXVhbGlmaWVyPUEyN1RBVFJKVUlZRUhZJmVuY3J5cHRlZElkPUEwNjUyNDk4MjE4T1hUT1RLQ1o3NyZlbmNyeXB0ZWRBZElkPUEwMzM1NDA0M0xQVFhFRkRITVQzRSZ3aWRnZXROYW1lPXNwX210ZiZhY3Rpb249Y2xpY2tSZWRpcmVjdCZkb05vdExvZ0NsaWNrPXRydWU=',
        'volumeTier': 'M'
      },
      {
        'id': 10,
        'amount': 1,
        'category': {
          'id': 10,
        },
        'detail': '',
        'freeShipping': true,
        'image': 'https://images-na.ssl-images-amazon.com/images/I/51ViKqADnVL._SL1000_.jpg',
        'name': 'Aputure Amaran AL-MX LED Video Light 128 SMD LED Bi-Color On-Camera Video Light',
        'onlineStore': {
          'id': 'ST04287859',
          'logo': 'https://res.cloudinary.com/qempo/image/upload/v1551903426/static/stores/Amazon.png',
          'name': 'Amazon',
          'type': 'online-store'
        },
        'price': '149.00',
        'taxFree': false,
        'url': 'https://www.amazon.com/Aputure-Bi-Color-Camera-2800-6500K-Adjustable/dp/B07C7NX2PH/ref=sr_1_4?keywords=aputure&qid=1571614390&s=electronics&sr=1-4',
        'volumeTier': 'M'
      },
      {
        'id': 11,
        'amount': 1,
        'category': {
          'id': 4,
        },
        'detail': 'Style: HERO7 Black, Configuration: Base Package',
        'freeShipping': true,
        'image': 'https://images-na.ssl-images-amazon.com/images/I/71LyTRGqB4L._SL1500_.jpg',
        'name': 'GoPro HERO 7 Black',
        'onlineStore': {
          'id': 'ST04287860',
          'logo': 'https://res.cloudinary.com/qempo/image/upload/v1551903426/static/stores/Amazon.png',
          'name': 'Amazon',
          'type': 'online-store'
        },
        'price': '327.00',
        'taxFree': false,
        'url': 'https://www.amazon.com/GoPro-HERO7-Black-Waterproof-Streaming-Stabilization/dp/B07GDGZCCH/ref=sxin_7_osp17-024c1d8f_cov?ascsubtag=024c1d8f-2384-4ed6-836f-945fae1a799b&creativeASIN=B07GDGZCCH&cv_ct_id=amzn1.osp.024c1d8f-2384-4ed6-836f-945fae1a799b&cv_ct_pg=search&cv_ct_wn=osp-search&keywords=underwater+camera&linkCode=oas&pd_rd_i=B07GDGZCCH&pd_rd_r=9eff8944-4526-491f-8555-9be0d67383de&pd_rd_w=ukind&pd_rd_wg=8fEzZ&pf_rd_p=a23a388c-add5-49df-b293-a31ade89c6bf&pf_rd_r=TD5AW438708D6WR33ZJE&qid=1571614503&s=electronics&tag=digitaltren0b-20',
        'volumeTier': 'S'
      },
      {
        'id': 12,
        'amount': 1,
        'category': {
          'id': 9,
        },
        'detail': 'Color: Ash',
        'freeShipping': true,
        'image': 'https://images-na.ssl-images-amazon.com/images/I/71qApCkiTBL._SL1500_.jpg',
        'name': 'Peak Design Everyday Sling Camera Bag',
        'onlineStore': {
          'id': 'ST04287861',
          'logo': 'https://res.cloudinary.com/qempo/image/upload/v1551903426/static/stores/Amazon.png',
          'name': 'Amazon',
          'type': 'online-store'
        },
        'price': '99.95',
        'taxFree': false,
        'url': 'https://www.amazon.com/Peak-Design-Everyday-Sling-Camera/dp/B0769RPR52/ref=sr_1_3?keywords=camera%2Bbag%2Bpeak&qid=1571613566&sr=8-3&th=1',
        'volumeTier': 'M'
      }
    ],
    'name': 'Esenciales para foto y video',
    'isOwner': false,
  },
  'esenciales-para-gamers': {
    'image': gamers,
    'items': [
      {
        'id': 1,
        'amount': 1,
        'category': {
          'id': 1,
        },
        'detail': '8th Gen Intel Core i7-8750H 6-Core, 17.3 Inch FHD 1920x1080 60Hz IPS, 16GB 2666MHz DDR4 RAM,  512GB SSD, NVIDIA GeForce RTX 2070 Max Q',
        'freeShipping': true,
        'image': 'https://images-na.ssl-images-amazon.com/images/I/61-yILIyhvL._SX679_.jpg',
        'name': 'Alienware M17 Gaming Notebook ',
        'onlineStore': {
          'id': 'ST04287850',
          'logo': 'https://res.cloudinary.com/qempo/image/upload/v1551903426/static/stores/Amazon.png',
          'name': 'Amazon',
          'type': 'online-store'
        },
        'price': '1599.99',
        'taxFree': false,
        'url': 'https://www.amazon.com/Alienware-Notebook-i7-8750H-1920x1080-2666MHz/dp/B07P2JH6MS/ref=sr_1_5?keywords=alienware&qid=1571598810&sr=8-5',
        'volumeTier': 'NA'
      },
      {
        'id': 2,
        'amount': 1,
        'category': {
          'id': 5,
        },
        'detail': '32gb',
        'freeShipping': true,
        'image': 'https://images-na.ssl-images-amazon.com/images/I/610iXon9LfL._AC_.jpg',
        'name': 'Oculus Go Standalone Virtual Reality Headset - 32GB',
        'onlineStore': {
          'id': 'ST04287850',
          'logo': 'https://res.cloudinary.com/qempo/image/upload/v1551903426/static/stores/Amazon.png',
          'name': 'Amazon',
          'type': 'online-store'
        },
        'price': '199.00',
        'taxFree': false,
        'url': 'https://www.amazon.com/Oculus-Standalone-Virtual-Reality-Headset-pc/dp/B076CWS8C6/ref=sr_1_1_sspa?keywords=oculus&qid=1571598466&sr=8-1-spons&spLa=ZW5jcnlwdGVkUXVhbGlmaWVyPUEzVDJPOFJXODE1UVNPJmVuY3J5cHRlZElkPUEwMzExOTM0ODMzNEdPV1JWSjZIJmVuY3J5cHRlZEFkSWQ9QTAyMDQ5MzkyU0QwQTAxRjAxNzVGJndpZGdldE5hbWU9c3BfYXRmJmFjdGlvbj1jbGlja1JlZGlyZWN0JmRvTm90TG9nQ2xpY2s9dHJ1ZQ&th=1',
        'volumeTier': 'M'
      },
      {
        'id': 3,
        'amount': 1,
        'category': {
          'id': 2,
        },
        'detail': 'Style: Rival 71\n',
        'freeShipping': true,
        'image': 'https://images-na.ssl-images-amazon.com/images/I/81wRhn6mF-L._SX679_.jpg',
        'name': 'SteelSeries Rival 710 Gaming Mouse',
        'onlineStore': {
          'id': 'ST04287850',
          'logo': 'https://res.cloudinary.com/qempo/image/upload/v1551903426/static/stores/Amazon.png',
          'name': 'Amazon',
          'type': 'online-store'
        },
        'price': '78.00',
        'taxFree': false,
        'url': 'https://www.amazon.com/SteelSeries-Rival-710-Gaming-Mouse/dp/B07G1WSLYR/ref=sxin_4_osp17-d65174c8_cov?ascsubtag=d65174c8-3c5c-42a4-b4f6-dafd4b4718b4&creativeASIN=B07G1WSLYR&cv_ct_id=amzn1.osp.d65174c8-3c5c-42a4-b4f6-dafd4b4718b4&cv_ct_pg=search&cv_ct_wn=osp-search&keywords=gaming+mouse&linkCode=oas&pd_rd_i=B07G1WSLYR&pd_rd_r=0e3cd9c8-153e-4508-9131-14caa17874e8&pd_rd_w=Bri80&pd_rd_wg=w74az&pf_rd_p=a23a388c-add5-49df-b293-a31ade89c6bf&pf_rd_r=EB09XPA08QESJ4PB76S9&qid=1571598725&tag=digitaltren0b-20',
        'volumeTier': 'S'
      },
      {
        'id': 4,
        'amount': 1,
        'category': {
          'id': 2,
        },
        'detail': '',
        'freeShipping': true,
        'image': 'https://images-na.ssl-images-amazon.com/images/I/71y3EdgHaXL._SX679_.jpg',
        'name': 'Alienware Low-Profile RGB Gaming Keyboard AW510K',
        'onlineStore': {
          'id': 'ST04287850',
          'logo': 'https://res.cloudinary.com/qempo/image/upload/v1551903426/static/stores/Amazon.png',
          'name': 'Amazon',
          'type': 'online-store'
        },
        'price': '159.99',
        'taxFree': false,
        'url': 'https://www.amazon.com/Alienware-Low-Profile-RGB-Gaming-Keyboard/dp/B07V8MXJB1/ref=sr_1_2_sspa?keywords=alienware&qid=1571598810&sr=8-2-spons&psc=1&spLa=ZW5jcnlwdGVkUXVhbGlmaWVyPUEyNkFEQTczNVZORU5TJmVuY3J5cHRlZElkPUEwMTAyNDg2M0kyU000MzZLSjVBUyZlbmNyeXB0ZWRBZElkPUEwMTM5MDg2MjRUNVVMQUc4U1lBRCZ3aWRnZXROYW1lPXNwX2F0ZiZhY3Rpb249Y2xpY2tSZWRpcmVjdCZkb05vdExvZ0NsaWNrPXRydWU=',
        'volumeTier': 'L'
      },
      {
        'id': 5,
        'amount': 1,
        'category': {
          'id': 10,
        },
        'detail': 'Style: Nimbus - iOS',
        'freeShipping': true,
        'image': 'https://images-na.ssl-images-amazon.com/images/I/61k8Iy5ljYL._SX679_.jpg',
        'name': 'SteelSeries Nimbus Bluetooth Mobile Gaming Controller',
        'onlineStore': {
          'id': 'ST04287850',
          'logo': 'https://res.cloudinary.com/qempo/image/upload/v1551903426/static/stores/Amazon.png',
          'name': 'Amazon',
          'type': 'online-store'
        },
        'price': '49.48',
        'taxFree': false,
        'url': 'https://www.amazon.com/SteelSeries-Nimbus-Bluetooth-Mobile-Controller/dp/B01AZC3III/ref=sr_1_9?keywords=fortnite+gaming&qid=1571599316&sr=8-9',
        'volumeTier': 'S'
      },
      {
        'id': 6,
        'amount': 1,
        'category': {
          'id': 9,
        },
        'detail': '',
        'freeShipping': true,
        'image': 'https://images-na.ssl-images-amazon.com/images/I/81OBjKIaldL._SX679_.jpg',
        'name': 'Alienware Vindicator Backpack 18-Inch',
        'onlineStore': {
          'id': 'ST04287850',
          'logo': 'https://res.cloudinary.com/qempo/image/upload/v1551903426/static/stores/Amazon.png',
          'name': 'Amazon',
          'type': 'online-store'
        },
        'price': '99.42',
        'taxFree': false,
        'url': 'https://www.amazon.com/Alienware-Vindicator-Backpack-18-Inch-AWVBP18/dp/B00FO6HNGY/ref=sr_1_2?keywords=alienware+backpack&qid=1571598827&sr=8-2',
        'volumeTier': 'M'
      },
      {
        'id': 7,
        'amount': 1,
        'category': {
          'id': 3,
        },
        'detail': '',
        'freeShipping': true,
        'image': 'https://images-na.ssl-images-amazon.com/images/I/51SNXQlMuJL._SX679_.jpg',
        'name': 'ASUS ROG Gaming Phone II ',
        'onlineStore': {
          'id': 'ST04287850',
          'logo': 'https://res.cloudinary.com/qempo/image/upload/v1551903426/static/stores/Amazon.png',
          'name': 'Amazon',
          'type': 'online-store'
        },
        'price': '899.00',
        'taxFree': false,
        'url': 'https://www.amazon.com/ASUS-ROG-Gaming-Phone-ZS660KL-S855P-12G512G-BK/dp/B07XPH822S/ref=sr_1_2?keywords=republic+of+gamers+phone&qid=1571599256&sr=8-2',
        'volumeTier': 'NA'
      },
      {
        'id': 8,
        'amount': 1,
        'category': {
          'id': 10,
        },
        'detail': 'Color: Black, Style: Artics 5',
        'freeShipping': true,
        'image': 'https://images-na.ssl-images-amazon.com/images/I/81Y9BnR2%2BhL._SY879_.jpg',
        'name': 'SteelSeries Arctis 5 - RGB Illuminated Gaming Headset',
        'onlineStore': {
          'id': 'ST04287850',
          'logo': 'https://res.cloudinary.com/qempo/image/upload/v1551903426/static/stores/Amazon.png',
          'name': 'Amazon',
          'type': 'online-store'
        },
        'price': '79.80',
        'taxFree': false,
        'url': 'https://www.amazon.com/SteelSeries-Arctis-Illuminated-Headset-Headphone/dp/B07FZQJ8PY/ref=sr_1_2?keywords=steelseries+headphones&qid=1571598582&sr=8-2',
        'volumeTier': 'M'
      },
      {
        'id': 9,
        'amount': 1,
        'category': {
          'id': 10,
        },
        'detail': '',
        'freeShipping': true,
        'image': 'https://images-na.ssl-images-amazon.com/images/I/71sPAw%2BpqbL._AC_.jpg',
        'name': 'ASTRO Gaming C40 TR Controller',
        'onlineStore': {
          'id': 'ST04287850',
          'logo': 'https://res.cloudinary.com/qempo/image/upload/v1551903426/static/stores/Amazon.png',
          'name': 'Amazon',
          'type': 'online-store'
        },
        'price': '199.99',
        'taxFree': false,
        'url': 'https://www.amazon.com/ASTRO-Gaming-C40-TR-Controller-PlayStation/dp/B07KF1FB1F/ref=sr_1_4?keywords=gaming+controller&qid=1571599330&sr=8-4',
        'volumeTier': 'S'
      },
      {
        'id': 10,
        'amount': 1,
        'category': {
          'id': 2,
        },
        'detail': 'Color: Soft Tactile - Cherry MX Brown Switch, Style: Professional w/ USB 3 Hub',
        'freeShipping': true,
        'image': 'https://images-na.ssl-images-amazon.com/images/I/61qNKCLTlHL._SL1500_.jpg',
        'name': 'Das Keyboard 4 Professional',
        'onlineStore': {
          'id': 'ST04287850',
          'logo': 'https://res.cloudinary.com/qempo/image/upload/v1551903426/static/stores/Amazon.png',
          'name': 'Amazon',
          'type': 'online-store'
        },
        'price': '169.00',
        'taxFree': false,
        'url': 'https://www.amazon.com/Das-Keyboard-Professional-Cherry-Mechanical/dp/B00JG01QTY/ref=sxin_4_osp17-2e0dcce2_cov?ascsubtag=2e0dcce2-8168-4d1c-933b-c45598bc5a53&creativeASIN=B00JG01QTY&cv_ct_id=amzn1.osp.2e0dcce2-8168-4d1c-933b-c45598bc5a53&cv_ct_pg=search&cv_ct_wn=osp-search&keywords=mechanical+keyboard&linkCode=oas&pd_rd_i=B00JG01QTY&pd_rd_r=c68fd93d-0ae6-4b29-93cb-8b1e1e95e682&pd_rd_w=jVeCz&pd_rd_wg=OxATT&pf_rd_p=a23a388c-add5-49df-b293-a31ade89c6bf&pf_rd_r=5Y9JQWF0Z5WQHJGD49DF&qid=1571599539&tag=digitaltren0b-20',
        'volumeTier': 'L'
      },
      {
        'id': 11,
        'amount': 1,
        'category': {
          'id': 15,
        },
        'detail': '',
        'freeShipping': true,
        'image': 'https://images-na.ssl-images-amazon.com/images/I/7166EILHbsL._AC_.jpg',
        'name': 'Gunnar Gaming Glasses',
        'onlineStore': {
          'id': 'ST04287850',
          'logo': 'https://res.cloudinary.com/qempo/image/upload/v1551903426/static/stores/Amazon.png',
          'name': 'Amazon',
          'type': 'online-store'
        },
        'price': '35.11',
        'taxFree': false,
        'url': 'https://www.amazon.com/Gunnar-Optiks-Anti-Glare-not-machine-specific/dp/B00CAUTK0E/ref=sr_1_2_sspa?keywords=gunnar&qid=1571599684&smid=ATVPDKIKX0DER&sr=8-2-spons&spLa=ZW5jcnlwdGVkUXVhbGlmaWVyPUEzMUFLR0dHNTZLQzVJJmVuY3J5cHRlZElkPUEwMzEyMjYwMUs1MEIwTlYwR1JHMyZlbmNyeXB0ZWRBZElkPUEwMjk3MjcxMU1OTDdINk5NSjZVSCZ3aWRnZXROYW1lPXNwX2F0ZiZhY3Rpb249Y2xpY2tSZWRpcmVjdCZkb05vdExvZ0NsaWNrPXRydWU&th=1',
        'volumeTier': 'S'
      },
      {
        'id': 12,
        'amount': 1,
        'category': {
          'id': 16,
        },
        'detail': 'Color: Gray',
        'freeShipping': true,
        'image': 'https://images-na.ssl-images-amazon.com/images/I/71YC7GYYKAL._AC_.jpg',
        'name': 'Nintendo Switch Lite',
        'onlineStore': {
          'id': 'ST04287850',
          'logo': 'https://res.cloudinary.com/qempo/image/upload/v1551903426/static/stores/Amazon.png',
          'name': 'Amazon',
          'type': 'online-store'
        },
        'price': '199.96',
        'taxFree': false,
        'url': 'https://www.amazon.com/Nintendo-Switch-Lite-Gray/dp/B07V2BBMK4/ref=sr_1_3?keywords=switch&qid=1571609352&sr=8-3',
        'volumeTier': 'M'
      }
    ],
    'name': 'Esenciales para gamers',
    'isOwner': false,
  },
  'tecnologia-para-deportes': {
    'image': deportes,
    'items': [
      {
        'id': 1,
        'amount': 1,
        'category': {
          'id': 5,
        },
        'detail': 'Color: Black',
        'freeShipping': true,
        'image': 'https://images-na.ssl-images-amazon.com/images/I/61yKNXIjxQL._SL1500_.jpg',
        'name': 'Powerbeats Pro - Totally Wireless Earphones',
        'onlineStore': {
          'id': 'ST04287850',
          'logo': 'https://res.cloudinary.com/qempo/image/upload/v1551903426/static/stores/Amazon.png',
          'name': 'Amazon',
          'type': 'online-store'
        },
        'price': '199.95',
        'taxFree': false,
        'url': 'https://www.amazon.com/gp/slredirect/picassoRedirect.html/ref=pa_sp_atf_aps_sr_pg1_1?ie=UTF8&adId=A0420883T8ZDA4NZ6VVD&url=%2FPowerbeats-Pro-Totally-Wireless-Earphones%2Fdp%2FB07R5QD598%2Fref%3Dsr_1_1_sspa%3Fkeywords%3Dpowerbeats%2Bpro%26qid%3D1571609561%26smid%3DATVPDKIKX0DER%26sr%3D8-1-spons%26psc%3D1&qualifier=1571609561&id=1694693348772560&widgetName=sp_atf',
        'volumeTier': 'S'
      },
      {
        'id': 2,
        'amount': 1,
        'category': {
          'id': 5,
        },
        'detail': '',
        'freeShipping': true,
        'image': 'https://images-na.ssl-images-amazon.com/images/I/710UsuWfOkL._SL1500_.jpg',
        'name': 'The Skulpt Scanner. Measures Body Fat Percentage',
        'onlineStore': {
          'id': 'ST04287850',
          'logo': 'https://res.cloudinary.com/qempo/image/upload/v1551903426/static/stores/Amazon.png',
          'name': 'Amazon',
          'type': 'online-store'
        },
        'price': '97.99',
        'taxFree': false,
        'url': 'https://www.amazon.com/Percentage-Identifies-Strengths-Weaknesses-Personalized/dp/B01DDX0B2W',
        'volumeTier': 'M'
      },
      {
        'id': 3,
        'amount': 1,
        'category': {
          'id': 5,
        },
        'detail': 'Size: 44mm, Style: Space Gray Aluminum with Black Sport Band',
        'freeShipping': true,
        'image': 'https://images-na.ssl-images-amazon.com/images/I/71wu%2BHMAKBL._SL1500_.jpg',
        'name': 'Apple Watch Series 5 (GPS, 44mm)',
        'onlineStore': {
          'id': 'ST04287850',
          'logo': 'https://res.cloudinary.com/qempo/image/upload/v1551903426/static/stores/Amazon.png',
          'name': 'Amazon',
          'type': 'online-store'
        },
        'price': '414.00',
        'taxFree': false,
        'url': 'https://www.amazon.com/Apple-Watch-GPS-44mm-Aluminum/dp/B07XQXPF21/ref=sxin_2_ac_d_pm?ac_md=6-0-VW5kZXIgJDUwMA%3D%3D-ac_d_pm&keywords=apple+watch+5&pd_rd_i=B07XQXPF21&pd_rd_r=62cdaa5f-a79d-49e0-8a72-98fdbc558ac4&pd_rd_w=kgDeT&pd_rd_wg=DYCEQ&pf_rd_p=02e79b16-eab7-4369-852f-d04a58a4d9b5&pf_rd_r=5C4D653SDK61VN56BD3Z&psc=1&qid=1571609512&s=electronics',
        'volumeTier': 'S'
      },
      {
        'id': 4,
        'amount': 1,
        'category': {
          'id': 5,
        },
        'detail': 'Product Packaging: retail_packaging\n',
        'freeShipping': true,
        'image': 'https://images-na.ssl-images-amazon.com/images/I/71hQeb%2BExcL._SL1500_.jpg',
        'name': 'Motiv Ring Fitness, Sleep and Heart Rate Tracker',
        'onlineStore': {
          'id': 'ST04287850',
          'logo': 'https://res.cloudinary.com/qempo/image/upload/v1551903426/static/stores/Amazon.png',
          'name': 'Amazon',
          'type': 'online-store'
        },
        'price': '196.64',
        'taxFree': false,
        'url': 'https://www.amazon.com/Motiv-Ring-Fitness-Tracker-Android/dp/B07MV5LZZW/ref=sr_1_3?keywords=motiv&qid=1571612668&sr=8-3',
        'volumeTier': 'XS'
      },
      {
        'id': 5,
        'amount': 1,
        'category': {
          'id': 5,
        },
        'detail': 'Color: Black, Size: XS-S\n',
        'freeShipping': true,
        'image': 'https://images-na.ssl-images-amazon.com/images/I/71ttT1NCxYL._SL1500_.jpg',
        'name': 'Polar H10 Heart Rate Monitor',
        'onlineStore': {
          'id': 'ST04287850',
          'logo': 'https://res.cloudinary.com/qempo/image/upload/v1551903426/static/stores/Amazon.png',
          'name': 'Amazon',
          'type': 'online-store'
        },
        'price': '77.77',
        'taxFree': false,
        'url': 'https://www.amazon.com/Polar-Heart-Rate-Monitor-Women/dp/B07PM54P4N/ref=sr_1_1?dchild=1&keywords=polar+hr&qid=1571612686&sr=8-1',
        'volumeTier': 'S'
      },
      {
        'id': 6,
        'amount': 1,
        'category': {
          'id': 5,
        },
        'detail': '',
        'freeShipping': true,
        'image': 'https://images-na.ssl-images-amazon.com/images/I/81TYUzDG0wL._SL1500_.jpg',
        'name': 'Tangram Smart Rope Pure',
        'onlineStore': {
          'id': 'ST04287850',
          'logo': 'https://res.cloudinary.com/qempo/image/upload/v1551903426/static/stores/Amazon.png',
          'name': 'Amazon',
          'type': 'online-store'
        },
        'price': '59.95',
        'taxFree': false,
        'url': 'https://www.amazon.com/Tangram-Bluetooth-Enabled-Connected-Rotation/dp/B01N3MOVQX/ref=sr_1_5?dchild=1&keywords=smart+rope&qid=1571612357&sr=8-5',
        'volumeTier': 'S'
      },
      {
        'id': 7,
        'amount': 1,
        'category': {
          'id': 5,
        },
        'detail': '',
        'freeShipping': true,
        'image': 'https://images-na.ssl-images-amazon.com/images/I/8117veUaSTL._SL1500_.jpg',
        'name': 'Swimbuds Flip Headphones and 8 GB Waterproof MP3 Player',
        'onlineStore': {
          'id': 'ST04287850',
          'logo': 'https://res.cloudinary.com/qempo/image/upload/v1551903426/static/stores/Amazon.png',
          'name': 'Amazon',
          'type': 'online-store'
        },
        'price': '59.95',
        'taxFree': false,
        'url': 'https://www.amazon.com/Swimbuds-Headphones-Waterproof-Shuffle-Feature/dp/B018YKTD1Y/ref=sr_1_4?keywords=underwater+headphones&qid=1571612233&sr=8-4',
        'volumeTier': 'S'
      },
      {
        'id': 8,
        'amount': 1,
        'category': {
          'id': 5,
        },
        'detail': 'Color: Blue',
        'freeShipping': true,
        'image': 'https://images-na.ssl-images-amazon.com/images/I/61Bx0jEMbnL._SL1500_.jpg',
        'name': 'Bose SoundSport Free, True Wireless Sport Headphones',
        'onlineStore': {
          'id': 'ST04287850',
          'logo': 'https://res.cloudinary.com/qempo/image/upload/v1551903426/static/stores/Amazon.png',
          'name': 'Amazon',
          'type': 'online-store'
        },
        'price': '199.00',
        'taxFree': false,
        'url': 'https://www.amazon.com/Bose-SoundSport-Truly-Wireless-Headphones/dp/B0748JM8M5/ref=sr_1_9?keywords=sport+headphones&qid=1571609530&sr=8-9',
        'volumeTier': 'S'
      },
      {
        'id': 9,
        'amount': 1,
        'category': {
          'id': 5,
        },
        'detail': 'Style: Device Only',
        'freeShipping': true,
        'image': 'https://images-na.ssl-images-amazon.com/images/I/51AfjOm4yeL._SL1000_.jpg',
        'name': 'Garmin Edge 830, Performance GPS Cycling/Bike',
        'onlineStore': {
          'id': 'ST04287850',
          'logo': 'https://res.cloudinary.com/qempo/image/upload/v1551903426/static/stores/Amazon.png',
          'name': 'Amazon',
          'type': 'online-store'
        },
        'price': '374.92',
        'taxFree': false,
        'url': 'https://www.amazon.com/Garmin-Performance-Computer-Monitoring-Popularity/dp/B07QFG246X/ref=sr_1_4?keywords=cycling+garmin&qid=1571612283&sr=8-4',
        'volumeTier': 'S'
      },
      {
        'id': 10,
        'amount': 1,
        'category': {
          'id': 5,
        },
        'detail': 'Color: Black',
        'freeShipping': true,
        'image': 'https://images-na.ssl-images-amazon.com/images/I/71tn-bL3gJL._UX679_.jpg',
        'name': 'Fitbit Aria 2 Wi-Fi Smart Scale',
        'onlineStore': {
          'id': 'ST04287850',
          'logo': 'https://res.cloudinary.com/qempo/image/upload/v1551903426/static/stores/Amazon.png',
          'name': 'Amazon',
          'type': 'online-store'
        },
        'price': '106.99',
        'taxFree': false,
        'url': 'https://www.amazon.com/Fitbit-Aria-Wi-Fi-Smart-Scale/dp/B0752M6T6K/ref=sxin_4_osp35-914caed6_cov?ascsubtag=914caed6-f917-41db-bfa8-2a873675a491&creativeASIN=B0752M6T6K&cv_ct_id=amzn1.osp.914caed6-f917-41db-bfa8-2a873675a491&cv_ct_pg=search&cv_ct_wn=osp-search&keywords=fitbit+scale&linkCode=oas&pd_rd_i=B0752M6T6K&pd_rd_r=d6c17b17-addf-45c9-a19f-6323b1b9fad0&pd_rd_w=AnsCv&pd_rd_wg=9kXGl&pf_rd_p=53eff971-6e12-4016-9864-b6dfd929b2b3&pf_rd_r=28YECNP8HVVMAR417Q0W&qid=1571612395&tag=heavy0013-20',
        'volumeTier': 'M'
      },
      {
        'id': 11,
        'amount': 1,
        'category': {
          'id': 9,
        },
        'detail': 'Color: Charcoal Black\n',
        'freeShipping': true,
        'image': 'https://images-na.ssl-images-amazon.com/images/I/419IKHGCiXL.jpg',
        'name': 'Lumos Smart Bike Helmet with Wireless Turn Signal',
        'onlineStore': {
          'id': 'ST04287850',
          'logo': 'https://res.cloudinary.com/qempo/image/upload/v1551903426/static/stores/Amazon.png',
          'name': 'Amazon',
          'type': 'online-store'
        },
        'price': '179.00',
        'taxFree': false,
        'url': 'https://www.amazon.com/Lumos-220002-001-Kickstart-Helmet/dp/B07MKDBF7J/ref=sr_1_1?dchild=1&keywords=lumo&qid=1571612489&sr=8-1',
        'volumeTier': 'M'
      },
      {
        'id': 12,
        'amount': 1,
        'category': {
          'id': 5,
        },
        'detail': 'Edition: Charge 3 Activity Tracker, Color: Rose Gold/Blue Grey',
        'freeShipping': true,
        'image': 'https://images-na.ssl-images-amazon.com/images/I/719DSpWp3LL._UX679_.jpg',
        'name': 'Fitbit Charge 3 Fitness Activity Tracker\n',
        'onlineStore': {
          'id': 'ST04287850',
          'logo': 'https://res.cloudinary.com/qempo/image/upload/v1551903426/static/stores/Amazon.png',
          'name': 'Amazon',
          'type': 'online-store'
        },
        'price': '127.99',
        'taxFree': false,
        'url': 'https://www.amazon.com/Fitbit-Fitness-Activity-Tracker-Included/dp/B07FT93TY5/ref=sr_1_1_sspa?keywords=fitbit&qid=1571609582&sr=8-1-spons&psc=1&spLa=ZW5jcnlwdGVkUXVhbGlmaWVyPUExRzFUMFo1WUoxNFlLJmVuY3J5cHRlZElkPUEwMDg0NjMyMTBZNEZQWUdFVllFOSZlbmNyeXB0ZWRBZElkPUEwMTA4NzQ4MkFOTlY3SkFIS1VHTyZ3aWRnZXROYW1lPXNwX2F0ZiZhY3Rpb249Y2xpY2tSZWRpcmVjdCZkb05vdExvZ0NsaWNrPXRydWU=',
        'volumeTier': 'S'
      },
      {
        'id': 13,
        'amount': 1,
        'category': {
          'id': 5,
        },
        'detail': 'Color: Seafoam Green',
        'freeShipping': true,
        'image': 'https://images-na.ssl-images-amazon.com/images/I/71jt7zUhirL._SL1500_.jpg',
        'name': 'ozmo Watertight Rechargeable Bluetooth Smart Cup Hydration Tracker',
        'onlineStore': {
          'id': 'ST04287850',
          'logo': 'https://res.cloudinary.com/qempo/image/upload/v1551903426/static/stores/Amazon.png',
          'name': 'Amazon',
          'type': 'online-store'
        },
        'price': '59.99',
        'taxFree': false,
        'url': 'https://www.amazon.com/ozmo-Watertight-Rechargeable-Bluetooth-Hydration/dp/B01MXJDU16',
        'volumeTier': 'S'
      },
      {
        'id': 14,
        'amount': 1,
        'category': {
          'id': 5,
        },
        'detail': 'Style: Upright GO\n',
        'freeShipping': true,
        'image': 'https://images-na.ssl-images-amazon.com/images/I/71zfaqwpiQL._SL1500_.jpg',
        'name': 'Upright GO Original Posture Trainer and Corrector for Back',
        'onlineStore': {
          'id': 'ST04287850',
          'logo': 'https://res.cloudinary.com/qempo/image/upload/v1551903426/static/stores/Amazon.png',
          'name': 'Amazon',
          'type': 'online-store'
        },
        'price': '79.95',
        'taxFree': false,
        'url': 'https://www.amazon.com/Upright-Corrector-Strapless-Discrete-Confidence/dp/B0747YHYZF?tag=hicons-20',
        'volumeTier': 'S'
      }
    ],
    'name': 'Tecnología para deportes',
    'isOwner': false,
  }
};

export function getListUserWishListsEpic(action$: Observable<WishListAction>): Observable<WishListAction> {
  return action$.pipe(
    ofType(WISH_LIST_FETCH_LIST_USER_WISH_LISTS_REQUEST),
    debounceTime(600),
    mergeMap(() => getListUserWishListsApi().pipe(
      map((response: WishList[]) => getListUserWishListsSuccess(response)),
      catchError((e: HTTPError) => {
        if (Math.round(e.code / 100) === 5) {
          return of(getListUserWishListsError(e),
            setNewAlert('wishlist', 'error', undefined, 'httpErrors.fetch.500'),
          );
        } else if (e.code === 400) {
          return of(getListUserWishListsError(e),
            setNewAlert('wishlist', 'error', undefined, 'httpErrors.fetch.400'),
          );
        }
        return of(getListUserWishListsError(e));
      }))
    ));
}

export function getUserWishListEpic(action$: Observable<WishListAction>): Observable<WishListAction> {
  return action$.pipe(
    ofType(WISH_LIST_FETCH_USER_WISH_LIST_REQUEST),
    debounceTime(600),
    mergeMap(({ userId, nameSlug }) => {
        let obs;
        if (!userId) {
          if (!!customWishLists[nameSlug]) {
            obs = of(customWishLists[nameSlug]);
          } else obs = throwError({ code: 404, name: httpErrorsCodeMap[404] });
        } else {
          obs = getUserWishListApi({
            sort: 'UPDATED_AT',
            order: 'DESC',
          }, {
            route: endpoints.GET_USER_WISH_LIST
              .replace(':userId', userId)
              .replace(':nameSlug', nameSlug)
          });
        }
        return obs.pipe(
          map((response: WishList) => {
            const newItems = response.items.map((item: WishListItem) => ({ ...item, encoded: encodeProduct(item) }));
            return getUserWishListSuccess({ ...response, items: newItems });
          }),
          catchError((e: HTTPError) => {
            if (Math.round(e.code / 100) === 5) {
              return of(getUserWishListError(e),
                setNewAlert('wishlist', 'error', undefined, 'httpErrors.fetch.500'),
              );
            } else if (e.code === 400) {
              return of(getUserWishListError(e),
                setNewAlert('wishlist', 'error', undefined, 'httpErrors.fetch.400'),
              );
            } else if (e.code === 404) {
              return of(getUserWishListError(e),
                // setNewAlert('wishlist', 'error', undefined, 'httpErrors.fetch.400'),
                push('/'),
              );
            }
            return of(getUserWishListError(e));
          }))
      }
    ));
}

export function postWishListImageEpic(action$: Observable<WishListAction>): Observable<WishListAction> {
  return action$.pipe(
    ofType(WISH_LIST_POST_CREATE_USER_WISH_LIST_REQUEST),
    mergeMap((response: WishListRequest) => uploadImageApi(response.imageData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).pipe(
      map((uploadImageResponse: UploadImageResponse) => postImageSuccess(
        update(response, {
          $unset: ['imageData'],
          imageId: { $set: uploadImageResponse.id }
        }))),
      catchError((e: HTTPError) => {
        if (Math.round(e.code / 100) === 5) {
          return of(postCreateUserWishListError(e),
            setNewAlert('wishlist', 'error', undefined, 'httpErrors.post.500'),
          );
        } else if (e.code === 400) {
          return of(postCreateUserWishListError(e),
            setNewAlert('wishlist', 'error', undefined, 'httpErrors.post.400'),
          );
        }
        return of(postCreateUserWishListError(e));
      }))
    ));
}

export function postCreateUserWishListEpic(action$: Observable<WishListAction>): Observable<WishListAction> {
  return action$.pipe(
    ofType(WISH_LIST_POST_IMAGE_SUCCESS),
    debounceTime(600),
    mergeMap((response: WishListRequest) => postCreateUserWishListApi(response).pipe(
      map((response: WishList) => postCreateUserWishListSuccess(response)),
      catchError((e: HTTPError) => {
        if (Math.round(e.code / 100) === 5) {
          return of(postCreateUserWishListError(e),
            setNewAlert('wishlist', 'error', undefined, 'httpErrors.fetch.500'),
          );
        } else if (e.code === 400) {
          return of(postCreateUserWishListError(e),
            setNewAlert('wishlist', 'error', undefined, 'httpErrors.fetch.400'),
          );
        }
        return of(postCreateUserWishListError(e));
      }))
    ));
}

export function putEditUserWishListEpic(action$: Observable<WishListAction>): Observable<WishListAction> {
  return action$.pipe(
    ofType(WISH_LIST_EDIT_USER_WISH_LIST_REQUEST),
    debounceTime(600),
    mergeMap(({ wishListRequest, nameSlug }) => putUserWishListApi(wishListRequest, {
        route: endpoints.PUT_USER_WISH_LIST.replace(':nameSlug', nameSlug)
      }).pipe(
      map((response: WishList) => putEditUserWishListSuccess(response)),
      catchError((e: HTTPError) => {
        if (Math.round(e.code / 100) === 5) {
          return of(putEditUserWishListError(e),
            setNewAlert('wishlist', 'error', undefined, 'httpErrors.fetch.500'),
          );
        } else if (e.code === 400) {
          return of(putEditUserWishListError(e),
            setNewAlert('wishlist', 'error', undefined, 'httpErrors.fetch.400'),
          );
        }
        return of(putEditUserWishListError(e));
      }))
    ));
}

export function deleteUserWishListEpic(action$: Observable<WishListAction>): Observable<WishListAction> {
  return action$.pipe(
    ofType(WISH_LIST_DELETE_USER_WISH_LIST_REQUEST),
    debounceTime(600),
    mergeMap(({ nameSlug }) => deleteUserWishListApi(undefined, {
        route: endpoints.DELETE_USER_WISH_LIST
          .replace(':nameSlug', nameSlug)
      }).pipe(
      map((response: WishList[]) => deleteUserWishListSuccess(response)),
      catchError((e: HTTPError) => {
        if (Math.round(e.code / 100) === 5) {
          return of(deleteUserWishListError(e),
            setNewAlert('wishlist', 'error', undefined, 'httpErrors.fetch.500'),
          );
        } else if (e.code === 400) {
          return of(deleteUserWishListError(e),
            setNewAlert('wishlist', 'error', undefined, 'httpErrors.fetch.400'),
          );
        }
        return of(deleteUserWishListError(e));
      }))
    ));
}

export function postProductImageEpic(action$: Observable<WishListAction>): Observable<WishListAction> {
  return action$.pipe(
    ofType(WISH_LIST_POST_PRODUCT_REQUEST),
    mergeMap(({ product, userId, nameSlug }) => {
      const { image, imageURI } = product;
      let obs = of({});
      if (image) {
        obs = uploadImageURLApi({
          url: image,
          resourceGroup: 'PRODUCT',
        });
      } else if (imageURI) {
        const fd = new FormData();
        fd.append('file', dataURItoBlob(imageURI));
        fd.append('resourceGroup', 'PRODUCT');
        obs = uploadImageApi(fd, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
      }
      return obs.pipe(
        map((imageResponse: { id: string }) =>
          postProductImageSuccess(imageResponse.id, product, userId, nameSlug)),
        catchError((e: HTTPError) => {
          if (Math.round(e.code / 100) === 5) {
            return of(postProductError(e),
              setNewAlert('wishlist', 'error', undefined, 'httpErrors.fetch.500'),
            );
          } else if (e.code === 400) {
            return of(postProductError(e),
              setNewAlert('wishlist', 'error', undefined, 'httpErrors.fetch.400'),
            );
          }
          return of(postProductError(e));
        }));
    })
  );
}

export function postProductEpic(action$: Observable<WishListAction>): Observable<WishListAction> {
  return action$.pipe(
    ofType(WISH_LIST_POST_PRODUCT_IMAGE_SUCCESS),
    debounceTime(600),
    mergeMap(({ imageId, product, userId, nameSlug }) => {
        if (!!product) {
          product.imageId = imageId;
          delete product.imageURI;
          delete product.image;
        }
        return postProductApi(product, {
          route: endpoints.POST_PRODUCT
            .replace(':userId', userId)
            .replace(':nameSlug', nameSlug),
          queryParams: {
            sort: 'UPDATED_AT',
            order: 'DESC',
          },
        }).pipe(
          map((response: WishList) => postProductSuccess(response)),
          catchError((e: HTTPError) => {
            if (Math.round(e.code / 100) === 5) {
              return of(postProductError(e),
                setNewAlert('wishlist', 'error', undefined, 'httpErrors.fetch.500'),
              );
            } else if (e.code === 400) {
              return of(postProductError(e),
                setNewAlert('wishlist', 'error', undefined, 'httpErrors.fetch.400'),
              );
            }
            return of(postProductError(e));
          }))
      }
    ));
}

export function editProductImageEpic(action$: Observable<WishListAction>): Observable<WishListAction> {
  return action$.pipe(
    ofType(WISH_LIST_EDIT_PRODUCT_REQUEST),
    debounceTime(600),
    mergeMap(({ product, productId, userId, nameSlug }) => {
      const { image, imageURI } = product;
      let obs = of({});
      if (image) {
        obs = uploadImageURLApi({
          url: image,
          resourceGroup: 'PRODUCT',
        });
      } else if (imageURI) {
        const fd = new FormData();
        fd.append('file', dataURItoBlob(imageURI));
        fd.append('resourceGroup', 'PRODUCT');
        obs = uploadImageApi(fd, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
      } else {
        return of(editProductImageSuccess(product, productId, userId, nameSlug));
      }
      return obs.pipe(
        map((imageResponse: { id: string }) =>
          editProductImageSuccess(product, productId, userId, nameSlug, imageResponse.id)),
        catchError((e: HTTPError) => {
          if (Math.round(e.code / 100) === 5) {
            return of(editProductError(e),
              setNewAlert('wishlist', 'error', undefined, 'httpErrors.fetch.500'),
            );
          } else if (e.code === 400) {
            return of(editProductError(e),
              setNewAlert('wishlist', 'error', undefined, 'httpErrors.fetch.400'),
            );
          }
          return of(editProductError(e));
        })
      );
    }),
  );
}

export function editProductEpic(action$: Observable<WishListAction>): Observable<WishListAction> {
  return action$.pipe(
    ofType(WISH_LIST_EDIT_PRODUCT_IMAGE_SUCCESS),
    debounceTime(600),
    mergeMap(({ product, productId, userId, nameSlug, imageId }) => {
        if (product && imageId) {
          product.imageId = imageId;
          delete product.imageURI;
          delete product.image;
        }
        return editProductApi(product, {
          route: endpoints.EDIT_PRODUCT
            .replace(':userId', userId)
            .replace(':nameSlug', nameSlug)
            .replace(':productId', productId),
          queryParams: {
            sort: 'UPDATED_AT',
            order: 'DESC',
          },
        }).pipe(
          map((response: WishList) => {
            const newItems = response.items.map((item: WishListItem) => ({ ...item, encoded: encodeProduct(item) }));
            return editProductSuccess({ ...response, items: newItems });
          }),
          catchError((e: HTTPError) => {
            if (Math.round(e.code / 100) === 5) {
              return of(editProductError(e),
                setNewAlert('wishlist', 'error', undefined, 'httpErrors.fetch.500'),
              );
            } else if (e.code === 400) {
              return of(editProductError(e),
                setNewAlert('wishlist', 'error', undefined, 'httpErrors.fetch.400'),
              );
            }
            return of(editProductError(e));
          }))
      }
    ));
}

export function deleteProductEpic(action$: Observable<WishListAction>): Observable<WishListAction> {
  return action$.pipe(
    ofType(WISH_LIST_DELETE_PRODUCT_REQUEST),
    debounceTime(600),
    mergeMap(({ userId, nameSlug, productId }) => deleteProductApi(undefined, {
        route: endpoints.DELETE_PRODUCT
          .replace(':userId', userId)
          .replace(':nameSlug', nameSlug)
          .replace(':productId', productId),
        queryParams: {
          sort: 'UPDATED_AT',
          order: 'DESC',
        },
      }).pipe(
      map((response: WishList) => deleteProductSuccess(response)),
      catchError((e: HTTPError) => {
        if (Math.round(e.code / 100) === 5) {
          return of(deleteProductError(e),
            setNewAlert('wishlist', 'error', undefined, 'httpErrors.fetch.500'),
          );
        } else if (e.code === 400) {
          return of(deleteProductError(e),
            setNewAlert('wishlist', 'error', undefined, 'httpErrors.fetch.400'),
          );
        }
        return of(deleteProductError(e));
      }))
    ));
}

export function editWishListLikeEpic(action$: Observable<WishListAction>): Observable<WishListAction> {
  return action$.pipe(
    ofType(WISH_LIST_EDIT_LIKE_REQUEST),
    debounceTime(600),
    mergeMap(({ liked, userId, nameSlug }) => {
        let obs;
        if (liked) {
          obs = postLikeApi({}, {
            route: endpoints.POST_LIKE
              .replace(':userId', userId)
              .replace(':nameSlug', nameSlug),
          });
        } else {
          obs = postUnlikeApi({}, {
            route: endpoints.POST_UNLIKE
              .replace(':userId', userId)
              .replace(':nameSlug', nameSlug),
          });
        }
        return obs.pipe(
          map(editLikeSuccess),
          catchError((e: HTTPError) => {
            if (Math.round(e.code / 100) === 5) {
              return of(editLikeErrorFn(e),
                setNewAlert('wishlist', 'error', undefined, 'httpErrors.fetch.500'),
              );
            } else if (e.code === 400) {
              return of(editLikeErrorFn(e),
                setNewAlert('wishlist', 'error', undefined, 'httpErrors.fetch.400'),
              );
            }
            return of(editLikeErrorFn(e));
          }))
      }
    ));
}



// WEBPACK FOOTER //
// ./src/modules/wish-list/duck.js